import React, { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './VerifyEmail.module.css';
import { confirmEmailVerification } from '../../apis/api';
import Loading from '../../components/Loading/Loading';

const VerifyEmail = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const token = useMemo(() => {
        const params = new URLSearchParams(location.search);
        return params.get('token') || '';
    }, [location.search]);

    const [status, setStatus] = useState('loading'); // loading | success | error
    const [message, setMessage] = useState('이메일 인증을 처리 중입니다...');

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            if (!token) {
                setStatus('error');
                setMessage('인증 토큰이 없습니다. 이메일 링크를 다시 확인해주세요.');
                return;
            }

            try {
                const data = await confirmEmailVerification(token);
                if (cancelled) return;
                setStatus('success');
                setMessage(data?.message || '이메일 인증이 완료되었습니다.');
            } catch (e) {
                if (cancelled) return;
                const apiMessage = e?.response?.data?.message;
                setStatus('error');
                setMessage(typeof apiMessage === 'string' ? apiMessage : '이메일 인증에 실패했습니다.');
            }
        };

        run();
        return () => {
            cancelled = true;
        };
    }, [token]);

    return (
        <div className={styles.container}>
            {status === 'loading' && <Loading />}

            <div className={styles.card}>
                <div className={styles.title}>이메일 인증</div>
                <div className={status === 'success' ? styles.success : styles.error}>{message}</div>

                <div className={styles.actions}>
                    <button className={styles.button} onClick={() => navigate('/login')}>
                        로그인으로 이동
                    </button>
                    <button className={styles.buttonSecondary} onClick={() => navigate('/home')}>
                        홈으로 이동
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;
